import { Inject, Service } from 'vue-di-container';

import { UserModel } from '@/models/user';
import HttpService from './httpService';
import { ApiConfigs } from '@/configs/apis';

@Service()
export default class UserService {
  @Inject(HttpService) public httpService!: HttpService;
  userInfo!:UserModel;

  public async getUser(): Promise<UserModel> {
    if (this.userInfo) {
      return this.userInfo;
    };

    try {
      const { data } = await this.httpService.httpInstance.get<UserModel>(ApiConfigs.baseUrls.userInfo);

      return data;
    } catch (err) {
      return {} as UserModel;
    }
  }
}
